import Konva from 'konva';

/**
 * Picks the geometric child of a shape Group whose bounding box we should center on.
 * Falls back to the Group itself for non-Group nodes or empty groups.
 */
export const getBookingMapCenteringSourceNode = (node: Konva.Node | undefined): Konva.Node | undefined => {
  if (!node) {
    return undefined;
  }

  if (node.getType() !== 'Group') {
    return node;
  }

  const group = node as Konva.Group;

  return group.findOne('Rect') ?? group.findOne('Ellipse') ?? group.findOne('Line') ?? group;
};
